import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";

import { QuestionReservationDefaultPlanID } from "./default-plan-id";
import { QuestionReservationRequiredPlanSelectForReservation } from "./required-plan-select-for-reservation";
import { useReservationRequiredPlanSelectForReservation } from "./required-plan-select-for-reservation/hooks";

export const QuestionReservationPlanSettings = () => {
	const { isEdited: isEdited_requiredPlanSelectForReservation, hasError: hasError_requiredPlanSelectForReservation } =
		useReservationRequiredPlanSelectForReservation();

	const isEdited = isEdited_requiredPlanSelectForReservation;
	const hasError = hasError_requiredPlanSelectForReservation;

	const title = "予約に関するプラン設定";
	const guide =
		"予約時のプラン選択を必須にできます。<br /> 食事付きプランがデフォルトである場合や、部屋単体での素泊まり予約を受け入れてない場合は、 プランの選択を必須に設定してください。";

	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title={title}
			isEdited={isEdited}
			hasError={hasError}
			guide={guide}
			inputChildren={
				<div className="flex flex-col gap-y-8">
					<QuestionReservationRequiredPlanSelectForReservation />
					<QuestionReservationDefaultPlanID />
				</div>
			}
		/>
	);
};

QuestionReservationPlanSettings.displayName = "QuestionReservationPlanSettings";
